import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const TitleRow = ({dateTime, name, location }) => {
    const { t } = useTranslation();
    return (
    <div style={{
        width: '100%',
        padding: '4px 0'
    }}>
        <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            marginBottom: '4px'
        }}>

            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                marginBottom: '4px'
            }}>
                <div style={{ flex: 0.2, textAlign: 'left', fontWeight: 'bold', fontSize: '0.8rem' }}>
                    {t("GanapathiInvocation")}
                </div>
                <div style={{ flex: 0.6, textAlign: 'center', fontWeight: 'bold', fontSize: '1rem' }}>
                    {t("JANMA_REPORT")}
                </div>
                <div style={{ flex: 0.2, textAlign: 'left', fontWeight: 'bold', fontSize: '0.8rem' }}>
                </div>
            </div>
            
        </div>
        <div style={{
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            marginTop: '4px'
        }}>
            <div style={{ flex: '0 0 20%', fontWeight: 'bold', fontSize: '0.8rem', textAlign: 'left', paddingRight: '8px' }}>
                {t("Name")}:
            </div>
            <div style={{ flex: '0 0 80%' }}>
                <input
                    type="text"
                    style={{ width: '100%', fontSize: '0.8rem', padding: '2px 4px' }}
                    defaultValue={name}
                    name="namaand"
                />
            </div>
        </div><div style={{
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            marginTop: '4px'
        }}>
            <div style={{ flex: '0 0 20%', fontWeight: 'bold', fontSize: '0.8rem', textAlign: 'left', paddingRight: '8px' }}>
                {t("Time")}:
            </div>
            <div style={{ flex: '0 0 80%', fontSize: '0.8rem' }}>
                <span>{dateTime}</span>
            </div>
        </div>
        <div style={{
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            marginTop: '4px'
        }}>
            <div style={{ flex: '0 0 20%', fontWeight: 'bold', fontSize: '0.8rem', textAlign: 'left', paddingRight: '8px' }}>
                {t("LOCATION")}:
            </div>
            <div style={{ flex: '0 0 80%', fontSize: '0.8rem' }}>
                <span>{location}</span>
            </div>
        </div>
        
    </div>
    );
};

TitleRow.propTypes = {
    dateTime: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    location: PropTypes.string.isRequired,
};

export default TitleRow;